import { Link as RouterLink } from 'react-router-dom';
import useTranslatedText from 'src/hooks/useTranslatedText';
import { Box, ButtonBase } from '@mui/material';
import { BRAND_LOGO_WHITE } from './portals';

export default function AuthPortalMenu() {
  const { t } = useTranslatedText();
  return (
    <ButtonBase
      component={RouterLink}
      to="/"
      aria-label={t('auth.home', { defaultValue: 'Universe home' })}
      sx={{ position: 'relative', zIndex: 1, pointerEvents: 'auto', alignSelf: 'flex-start', minHeight: 44, borderRadius: 1, color: '#FFFFFF', '&:focus-visible': { outline: '2px solid currentColor', outlineOffset: 4 } }}
    >
      <Box component="img" src={BRAND_LOGO_WHITE} alt="Universe" sx={{ height: { xs: 26, md: 34 }, width: 'auto', maxWidth: 240 }} />
    </ButtonBase>
  );
}
